var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-form__block"},[_c('div',{staticClass:"m-field"},[_c('div',{staticClass:"m-field__label"},[_vm._v(_vm._s(_vm.label))]),_c('textarea',{staticClass:"a-textarea",domProps:{"value":_vm.value},on:{"change":(v) => _vm.$emit('input', v.target.value)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }